// core/services/premiumService.ts — plan/benefit MARKETING COPY only.
//
// Pure read-only static data (tier names, taglines, benefit blurbs) — never
// used for entitlement decisions. Real subscription STATE (tier, status,
// renewal) is core/services/billingService.ts + hooks/useBilling.ts, backed
// by GET /billing/me/. Components must not import this directly; use
// hooks/usePremium.ts.

import type { PremiumTier, UltraBenefit } from '@/core/models/premium';
import { seedTiers, seedUltraBenefits } from '@/core/data/premium';
import { authService } from './authService';

export const premiumService = {
  /** Return all premium tiers in display order. */
  async tiers(): Promise<PremiumTier[]> {
    return seedTiers;
  },

  /** Return a single tier by id, or undefined if not found. */
  async tier(id: string): Promise<PremiumTier | undefined> {
    return seedTiers.find((t) => t.id === id);
  },

  /** Return the ultra benefit icon-card grid items. */
  async ultraBenefits(): Promise<UltraBenefit[]> {
    return seedUltraBenefits;
  },

  /**
   * Return whether the current user is subscribed to any premium tier.
   * Reads the active account's premium flag from the session (a mirror kept
   * in sync by the billing webhook — see apps.billing.entitlements). For the
   * authoritative real-time tier/status, use hooks/useBilling.ts instead.
   */
  async isSubscribed(): Promise<boolean> {
    return authService.isPremium();
  },
} as const;
